/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import React, {useEffect, useState } from "react";
import PropTypes from "prop-types";
import Chip from "@mui/material/Chip";
import { Grid2, IconButton } from "@mui/material";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import "./ApplicationDetailsCountries.css";
import ApplicationModal from "../ApplicationModal/ApplicationModal";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "5px",
  p: 4,
};

function ApplicationDetailsCountries({
  countries,
  submissionData,
  postCallTheNewSubmission,
  checkedDefaultAll,
}) {
  const [countris, setCountris] = useState([]);
  const [showCountries, setShowCountries] = useState([]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);
  const [openModal, setOpenModal] = React.useState(false);
  const name = "Countries";
  useEffect(() => {
    if (submissionData && Object.keys(submissionData).length > 0) {
      const newCountriesArray =
        submissionData.targeting.countriesInclusions.map((countryId) => {
          let index = countries.findIndex(
            (country) => country.id === countryId
          );
          if (index !== -1) {
            return countries[index];
          }
        });
      const sortedData = [...newCountriesArray].sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      setShowCountries(sortedData.slice(0, 20));
      setCountris(sortedData);
    }
  }, [countries, submissionData]);

  useEffect(() => {
    if (checkedDefaultAll) {
      changeCountris();
    }
  }, [checkedDefaultAll]);

  const sendPostSubmissionCall = (selectedData) => {
    let targetCountries = selectedData.map((country) => {
      return country.id;
    });
    let newSubmissionData = { ...submissionData };
    newSubmissionData.targeting.countriesInclusions = [...targetCountries];
    delete newSubmissionData["legalDocuments"];
    postCallTheNewSubmission(newSubmissionData);
  };

  const showDialog = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleOk = () => {
    setOpen(false);
  };

  const changeCountris = () => {
    const newCountriesArray = submissionData.targeting.countriesInclusions.map(
      (countryId) => {
        let index = countries.findIndex((country) => country.id === countryId);
        if (index !== -1) {
          return countries[index];
        }
      }
    );
    setShowCountries(newCountriesArray.slice(0, 20));
    setCountris(newCountriesArray);
  };

  return (
    <section className="countries">
      <div className="wrapper-diver">
        <p className="text-countries-title">
          Countries <span className="required">*</span>
        </p>
        <div style={{ marginTop: "6px !important" }}>
          {submissionData &&
          Object.keys(submissionData).length > 0 &&
          submissionData.status === "DRAFT" ? (
            <Button
              className="set-button"
              variant="outlined"
              onClick={handleOpen}
              style={{
                textTransform: "none",
              }}
            >
              Set
            </Button>
          ) : (
            <Button
              className="set-button"
              variant="outlined"
              onClick={handleOpen}
              style={{
                textTransform: "none",
              }}
            >
              View
            </Button>
          )}
        </div>
      </div>
      {
        <div className="wrapper-diver-show-data">
          <div>
            <Grid2 direction="row" rowsGap={5} spacing={2}>
              {showCountries &&
                showCountries.length > 0 &&
                showCountries.map((cntry) => {
                  return (
                    <Chip
                      key={cntry.id}
                      sx={{
                        height: "24px !important",
                        "font-weight": 400,
                        "font-size": "12px",
                        color: "#5A5B5C",
                      }}
                      id={cntry.id}
                      label={cntry.name}
                      className="chip-text"
                      style={{
                        borderRadius: "5px",
                        marginRight: "8px",
                        marginBottom: "8px",
                      }}
                    ></Chip>
                  );
                })}
              {showCountries.length < countris.length && (
                <Chip
                  id="see_more"
                  label="See More..."
                  style={{
                    border: 0,
                    fontSize: "12px",
                    backgroundColor: "white",
                    color: "#1565c0",
                  }}
                  onClick={showDialog}
                ></Chip>
              )}
            </Grid2>
          </div>
        </div>
      }
      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
        maxWidth="xs"
        open={open}
      >
        <DialogTitle>Countries</DialogTitle>
        <DialogContent dividers>
          <Grid2 direction="row" rowsGap={5} spacing={2}>
            {countris &&
              countris.length > 0 &&
              countris.map((cntry) => {
                return (
                  <Chip
                    key={cntry.id}
                    id={cntry.id}
                    label={cntry.name}
                    className="chip-text"
                    sx={{
                      height: "24px !important",
                      borderRadius: "5px",
                      marginRight: "8px",
                      marginBottom: "8px",
                    }}
                  ></Chip>
                );
              })}
          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCancel}>
            Cancel
          </Button>
          <Button onClick={handleOk}>Ok</Button>
        </DialogActions>
      </Dialog>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={{ ...style, width: 700, height: 460 }}>
          <h2 id="parent-modal-title">Targeting-Countries</h2>
          <div style={{ position: "absolute", right: "30px", top: "45px" }}>
            <IconButton>
              <CloseIcon onClick={handleClose} />
            </IconButton>
          </div>
          <secton>
            <ApplicationModal
              handleClose={handleClose}
              selectedData={countris}
              availabilty={countries}
              name={name}
              sendPostSubmissionCall={sendPostSubmissionCall}
              status={submissionData.status}
              changeCountris={changeCountris}
            />
          </secton>
        </Box>
      </Modal>
    </section>
  );
}

ApplicationDetailsCountries.propTypes = {
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
  submissionData: PropTypes.shape({
    status: PropTypes.string,
    targeting: PropTypes.shape({
      countriesInclusions: PropTypes.arrayOf(PropTypes.string),
    }),
  }).isRequired,
  postCallTheNewSubmission: PropTypes.func.isRequired,
  checkedDefaultAll: PropTypes.bool,
};

export default ApplicationDetailsCountries;
